module.exports = {"title":"连接·生活","open":"打开","openButton":"打开MyLink查看更多 ","download":"下载MyLink APP","ios":"请点击右上角的“...”按钮，选择“在Safari中打开”","android":"请点击右上角的“...”按钮，选择“在Safari中打开”","downloadApp":"立即下载MyLink浏览更多资讯","register":"安装完成，请注册或登入您的帐号"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/share/zh-cn.json
// module id = pftG
// module chunks = 1